module.exports = __webpack_public_path__ + "img/livinglab-logo-with-info-dark-bg.2225234d.svg";